import { render, staticRenderFns } from "./giftCard.vue?vue&type=template&id=76476ec7&"
import script from "./giftCard.vue?vue&type=script&lang=js&"
export * from "./giftCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports